import { render, staticRenderFns } from "./CadastroTributacao.vue?vue&type=template&id=4fe5e250&scoped=true"
import script from "./CadastroTributacao.vue?vue&type=script&lang=js"
export * from "./CadastroTributacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe5e250",
  null
  
)

export default component.exports